import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import css from './ContextFilesDebug.css';

const ContextFilesDebug = ({ files }) => {
    const contextFiles = Array.isArray(files) ? files : [];

    if (contextFiles.length === 0) return null;

    return (
        <div className={css.contextFilesDebug}>
            <Icon
                name="file-text"
                size={IconSizes.X_SMALL}
                variant={IconVariants.LIGHT}
                interactive={false}
                className={css.contextFilesIcon}
                hoverText="Context files read"
            />
            <span className={css.contextFilesValue}>
                {contextFiles.map(file => (
                    <code key={file} className={css.contextFile}>{file}</code>
                ))}
            </span>
        </div>
    );
};

ContextFilesDebug.propTypes = {
    files: PropTypes.arrayOf(PropTypes.string),
};

export default ContextFilesDebug;
